module.exports = __webpack_public_path__ + "static/s1-poured-d-c290045df30234cdc4b3914059db3382.jpg";